module.exports = __webpack_public_path__ + "static/img/qrcode-modal.efddd26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/follow-modal/qrcode-modal.png
// module id = CQLm
// module chunks = 4